<div class="columns">
  <div class="column">
    <app-header
      header="sustainability.title"
      subHeader="sustainability.subtitle"
    ></app-header>
  </div>
</div>

<div class="box mt-4">
  <form [formGroup]="dateForm" novalidate class="columns my-4">
    <div class="column">
      <fino-datepicker
        formControlName="from"
        [config]="cancelDatePickerConfig"
        placement="bottom"
      ></fino-datepicker>
    </div>

    <div class="column">
      <fino-datepicker
        formControlName="to"
        [config]="cancelDatePickerConfig"
        placement="bottom"
      ></fino-datepicker>
    </div>
    <div class="column is-2 is-flex is-flex-direction-column">
      <button
        [primary]="true"
        [loading]="csvDownloading"
        type="button"
        class="is-fullheight"
        (click)="downloadAsCSV()"
        fino-button
        icon="File Csv 1"
        label="sustainability.download"
      ></button>
    </div>
  </form>
</div>

<div class="columns sustainability">
  @if (sustainabilityReport) {
    @for (item of items; track item) {
      <div class="column">
        <div
          class="box is-flex is-flex-direction-column is-justify-content-center is-align-items-center is-fullheight"
        >
          <svg-icon [src]="item.logo" alt="Center Image" />
          <h3 class="mt-4 is-title is-size-3 has-text-weight-bold">
            {{ sustainabilityReport[item.name] | number: '1.0-2' }}
            <span class="has-text-grey-light is-size-4">{{ item.unit }}</span>
          </h3>

          <p
            class="has-text-grey has-text-centered mt-4"
            [innerHtml]="
              'sustainability.description.' + item.name
                | translate
                  : {
                      value: sustainabilityReport[item.name] | number: '1.0-2'
                    }
            "
          ></p>

          @if (item.reference) {
            <p
              class="has-text-grey has-text-centered mt-4"
              [innerHtml]="
                'sustainability.reference.' + item.name
                  | translate
                    : {
                        value:
                          sustainabilityReport[item.name] | number: '1.0-2',
                        reference:
                          sustainabilityReport[item.name] * item.reference
                          | number: '1.0-2'
                      }
              "
            ></p>
          }
        </div>
      </div>
    }
  }
</div>
